import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http'
import { Meta } from '@angular/platform-browser';
import {Title} from '@angular/platform-browser';





@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})





export class AppComponent {
  constructor (private httpService: HttpClient, public meta: Meta, public titleService: Title) {}
  content;



  subdomain;
  meta_title;
  meta_description;
  meta_keywords;
  title;
  name;
  description;
  android_link;
  ios_link;
  footer_description;
  privacy_policy_title;
  privacy_policy_description;
  color_1;
  color_2;
  logo;
  background_img;
  background_color;
  favicon;
  font;
  google_analytics;








  ngOnInit () {





//
//
//
//
//   this.httpService.get('http://api.dev.qrtag.mobi/dupa2333/landingpage').subscribe(
//     data => {
//
//
//
//
//       // this.content = data;
//       // this.subdomain = this.content.subdomain;
//       // this.meta_title = this.content.meta_title;
//       // this.meta_description = this.content.meta_description;
//       // this.meta_keywords = this.content.meta_keywords;
//       // this.title = this.content.title;
//       // this.name = this.content.name;
//       // this.description = this.content.description;
//       // this.android_link = this.content.android_link;
//       // this.ios_link = this.content.ios_link;
//       // this.footer_description = this.content.footer_description;
//       // this.privacy_policy_title = this.content.privacy_policy_title;
//       // this.privacy_policy_description = this.content.privacy_policy_description;
//       // this.color_1 = this.content.color_1;
//       // this.color_2 = this.content.color_2;
//       // this.logo = this.content.logo;
//       // this.background_img = this.content.background_img;
//       // this.background_color = this.content.background_color;
//       // this.favicon = this.content.favicon;
//       // this.font = this.content.font;
//       // this.google_analytics = this.content.google_analytics;
//
//       // this.meta.addTag({ name: 'description', content: this.meta_description });
//       // this.meta.addTag({ name: 'keywords', content: this.meta_keywords });
//       // this.meta.addTag({ name: 'description', property:'og:url', content: this.meta_description });
//       // this.meta.addTag({ property:'og:url', content: this.subdomain });
//       // this.meta.addTag({ property:'og:title', content: this.meta_title });
//       // this.meta.addTag({ property:'og:image', content: this.background_img });
//       // this.meta.addTag({ property:'og:image:type', content: 'image/jpeg' });
//       // this.meta.addTag({ property:'og:image:width', content: '1200' });
//       // this.meta.addTag({ property:'og:height', content: '630' });
//       // this.titleService.setTitle(this.meta_title);
//
//
//
// //
// //   const css = "body{font-family: '"+this.font+"', sans-serif;color:"+this.color_1+";background-color:"+this.background_color+";}"+
// //
// // 	".navbar-default .navbar-header .navbar-brand,.navbar-default,.navbar-brand:hover{font-family: '"+this.font+"', sans-serif;background-color:"+this.color_2+";border:none;}"+
// //
// // 	".navbar-default .navbar-header .navbar-brand:hover,.navbar-default .navbar-header .navbar-brand:focus {color: "+this.color_2+";}"+
// //
// //   ".btn {font-family: '"+this.font+"', sans-serif;}"+
// //
// // 	"h1,h2,h3,h4,h5,h6 {font-family: '"+this.font+"', sans-serif;color: "+this.color_1+";}"+
// //
// // 	"a{color:"+this.color_1+";}"+
// //
// // 	"a:hover, a:focus {color: "+this.color_2+";}"+
// //
// // 	".header{ background: url('"+this.background_img+"') center bottom; color: "+this.color_1+"; background-color:"+this.color_2+"; }"+
// //
// //   "#contact{color:"+this.color_1+";background-color:"+this.color_2+";}"+
// //
// // 	".navbar-default .navbar-header .navbar-brand {color: "+this.color_1+";}"+
// //
// //   ".navbar-default .nav > li>a, .navbar-default .nav>li>a:focus {color: "+this.color_1+";}"+
// //
// //   ".btn-primary {color: "+this.color_1+";background: none !important;border: solid 2px "+this.color_1+";}"+
// //
// //   ".btn-primary:hover,.btn-primary:focus,.btn-primary.focus,.btn-primary:active,.btn-primary.active,.open > .dropdown-toggle.btn-primary {border: solid 2px "+this.color_1+";color: #0092fc;background-color: #ba34ad !important;}" +
// //
// //
// // ".btn-primary.disabled,.btn-primary[disabled],fieldset[disabled] .btn-primary,.btn-primary.disabled:hover,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary:hover,.btn-primary.disabled:focus,.btn-primary[disabled]:focus,fieldset[disabled] .btn-primary:focus,.btn-primary.disabled.focus,.btn-primary[disabled].focus,fieldset[disabled] .btn-primary.focus,.btn-primary.disabled:active,.btn-primary[disabled]:active,fieldset[disabled] .btn-primary:active,.btn-primary.disabled.active,.btn-primary[disabled].active,fieldset[disabled] .btn-primary.active {border-color: "+this.color_1+";background-color: "+this.color_1+";}"+
// //
// // "hr {border-color: "+this.color_1+";}";
// //
// //       const head = document.getElementsByTagName('head')[0];
// //       const style = document.createElement('style');
// //       style.type = 'text/css';
// //       style.appendChild(document.createTextNode(css));
// //       head.appendChild(style);
//
//
//
//
//
//
//
//       console.log(this.content);
//     },
//     (err: HttpErrorResponse) => {
//       console.log (err.message);
//     }
//   );
}
}
